import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Intro from './pages/Intro';

import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import './styles/App.css';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={
                    <>
                        <Header />
                        <main>
                            <Intro />
                        </main>
                    </>
                } />
                <Route path="/blogs" element={
                    <>
                        <Header />
                        <main><Blogs /></main>
                        <Footer />
                    </>
                } />
                <Route path="/blogs/:slug" element={
                    <>
                        <Header />
                        <main><BlogDetail /></main>
                        <Footer />
                    </>
                } />
            </Routes>
        </Router>
    );
};

export default App;